// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-components-nestedLinkBox-styles-module__block--atJXJ {
  position:relative;
}

.src-js-components-nestedLinkBox-styles-module__block--atJXJ .src-js-components-nestedLinkBox-styles-module__overlay--lQ0uk {
  position:absolute;
  left:0;
  top:0;
  bottom:0;
  right:0;
}

.src-js-components-nestedLinkBox-styles-module__block--atJXJ .src-js-components-nestedLinkBox-styles-module__inner--cppDI {
  position:relative;
  pointer-events: none;
  z-index: 1;
}

.src-js-components-nestedLinkBox-styles-module__block--atJXJ .src-js-components-nestedLinkBox-styles-module__inner--cppDI a {
  pointer-events: all;
  position:relative;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/nestedLinkBox/styles.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,MAAM;EACN,KAAK;EACL,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB","sourcesContent":[".block {\n  position:relative;\n}\n\n.block .overlay {\n  position:absolute;\n  left:0;\n  top:0;\n  bottom:0;\n  right:0;\n}\n\n.block .inner {\n  position:relative;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.block .inner a {\n  pointer-events: all;\n  position:relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"block": `src-js-components-nestedLinkBox-styles-module__block--atJXJ`,
	"overlay": `src-js-components-nestedLinkBox-styles-module__overlay--lQ0uk`,
	"inner": `src-js-components-nestedLinkBox-styles-module__inner--cppDI`
};
export default ___CSS_LOADER_EXPORT___;
